/*
 * Ryan O'Dowd
 * 2022-04-13
 * © Copyright 2021 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */

const getStyles = ({globalScale, colors}) => {
  return {
    container: {
      flex: 1,
      flexDirection: 'row',
      margin: 0,
      // @TODO: make this a little wider to fit more verses on screen
    },
    dragWrapper: {
      flex: 1,
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
    },
    dragIcon: {
      fontSize: globalScale * 22,
      color: colors.lightGray,
    },
    verseWrapper: {
      flex: 1,
      flexDirection: 'row',
      padding: 4,
    },
    verseNumberText: { // @TODO: @nathaniel: for some reason, this text will be truncated if the text isn't too long to wrap (e.g., make a note that's exactly as long as the width of this component and then add a character...it won't wrap, but the last character won't be visible either)
      position: 'absolute',
      top: 4,
      left: -4, // @TODO: if number is 3 digits, i think the number will run into the verse
      fontSize: globalScale * 11,
      color: colors.accent, // @TODO: if incorrect placement, this should be colors.incorrect
    },
    incorrectVerseNumberText: { // @TODO: @nathaniel: for some reason, this text will be truncated if the text isn't too long to wrap (e.g., make a note that's exactly as long as the width of this component and then add a character...it won't wrap, but the last character won't be visible either)
      color: colors.incorrect,
    },
    verseBodyText: {
      flex: 1,
      fontSize: globalScale * 18,
      padding: globalScale * 4,
      color: colors.white, // @TODO: on save, turn to accent if correct, turn to red if incorrect
    },
  };
};

export default getStyles;
